import React from 'react'
import { SvgProps } from './type'
import { Row } from '@components'
import { StyledSvg } from './style'
import icons from '@assets/icons'

const SvgImage: React.FC<SvgProps> = ({
  src,
  height,
  width,
  onClick,
  color,
  fill,
  size,
  ...props
}) => {
  return (
    <Row
      styleRow={{ height: size ?? height, width: size ?? width }}
      onClick={onClick}
    >
      <StyledSvg
        color={color || 'black'}
        fill={fill}
        style={{ height: '100%', width: '100%', color: color }}
        {...props}
        dangerouslySetInnerHTML={{ __html: icons[src] }}
      />
    </Row>
  )
}

export default SvgImage
